export class weightagesendapprovalModel {
  RoleListAPI: string;
  weightageApprovalListAPI: string;
  weightageApprovalIDAPI: string;
  weightageApprovalUpdateAPI: string;
  weightageSendApprovalAPI: string;


}
